import go from '@/gojs/go'

export default function (module, sheets, year) {
  const result = go.distribution[module](sheets, parseInt(year))
  result.year = year
  return result
}
